import { useMemo } from 'react'
import useAxios from 'axios-hooks'
import { DEFAULT_PAGINATION_SIZE } from 'utils/constants'

const NAMESPACE = 'scholarships-stage'

export const useGetOne = (id, { manual, showDifferences = true } = {}) => {
  const [
    { data, loading, error },
    reFetch,
  ] = useAxios({
    url: `${NAMESPACE}/${id}`,
    params: { showDifferences },
  }, { manual })

  return useMemo(() => ({
    data,
    loading,
    error,
    reFetch,
  }), [
    data,
    loading,
    error,
    reFetch,
  ])
}
